import React from "react";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import {Values} from "Tools/Values";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import {inject} from "mobx-react";
import {IAuthStore} from "Stores/Auth/types";
import {IValuesStore} from "Stores/Values/types";
import {FlexBoxRight} from "../../../../../Shared/styles";

interface IProps {
    isInternal: boolean;
    isEnabled: boolean;
    onEditButtonClick: () => void;
    onRemoveButtonClick: () => void;
    auth?: IAuthStore;
    values?: IValuesStore;
}

@inject("auth", "values")
class AppTableItemButtons extends React.Component<IProps> {
    checkIfEditInternalApp() {
        const isAdmin = this.props.auth.user.roles.find(x => x == this.props.values.roles.Administrator) != null;
        return isAdmin && this.props.isInternal;
    }

    getButtonIcon() {
        return this.props.isInternal ? <CreateIcon/> : <InfoOutlinedIcon/>
    }

    render() {
        return (
            <>
                {this.props.isEnabled ? (
                    <FlexBoxRight>
                        <RoundButton
                            icon={this.getButtonIcon()}
                            tooltipTitle={Values.getLocalizationValue(this.checkIfEditInternalApp() ? 'edit' : 'info')}
                            onClick={() => this.props.onEditButtonClick()}
                        />

                        <div style={{visibility: this.checkIfEditInternalApp() ? 'visible' : 'hidden'}}>
                            <RoundButton
                                icon={<DeleteIcon/>}
                                color="red"
                                tooltipTitle={Values.getLocalizationValue('remove')}
                                onClick={() => this.props.onRemoveButtonClick()}
                            />
                        </div>
                    </FlexBoxRight>
                ) : (
                    <RoundButton
                        icon={this.getButtonIcon()}
                        tooltipTitle={Values.getLocalizationValue('info')}
                        onClick={() => this.props.onEditButtonClick()}
                    />
                )}
            </>
        )
    }
}

export default AppTableItemButtons;
